import SingleButtonSelection from "common/bit/SingleButtonSelection"
import { Dispatch, SetStateAction } from "react"
import styled from "styled-components"
import { TypographyRtl } from "theme/shared"

const StyledWrapper = styled.div`
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 320px;
    margin: 0 auto;
  }
`

const StyledSingleButtonSelection = styled(SingleButtonSelection)`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  width: 100%;
  gap: 0px;
  background-color: ${(p) => p.theme.colors.saphire};
  border: 2px solid ${(p) => p.theme.colors.saphire};
  border-radius: 3px;
  overflow: hidden;
`
const StyledButton = styled.label<{ $activeButton: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 100%;
  :focus {
    outline: none;
  }
`

const StyleCardButton = styled.div<{ $activeButton: boolean }>`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  padding: 12px 0px;
  background-color: ${(p) =>
    p.$activeButton ? p.theme.colors.saphire : p.theme.colors.white};

  p {
    color: ${(p) =>
      p.$activeButton ? p.theme.colors.white : p.theme.colors.saphire};
  }
`
type ToggleButtonsProps = {
  activeButton: number
  setActiveButton: Dispatch<SetStateAction<number>>
  optionsList: string[]
  toggleId: string
  className?: string
  onSelect?: () => void
}

const TwoToggleButtons = ({
  activeButton,
  setActiveButton,
  optionsList,
  toggleId,
  className,
  onSelect,
}: ToggleButtonsProps) => {
  return (
    <StyledWrapper className={className}>
      <StyledSingleButtonSelection
        id={toggleId}
        items={optionsList.map((item, index) => ({
          value: index,
          name: item,
        }))}
        itemsPerRow={2}
        selectedValue={activeButton}
        onSelect={(code) => {
          setActiveButton(Number(code))
          if (onSelect) {
            onSelect?.()
          }
        }}
        customButton={(radioId, isSelected, item) => (
          <StyledButton htmlFor={radioId} $activeButton={isSelected}>
            <StyleCardButton $activeButton={isSelected}>
              <TypographyRtl variant="body2">{item.name}</TypographyRtl>
            </StyleCardButton>
          </StyledButton>
        )}
      />
    </StyledWrapper>
  )
}

export default TwoToggleButtons
